module.exports = __webpack_public_path__ + "img/more.9592b59b.svg";